module.exports = __webpack_public_path__ + "static/img/zdhf01.f715e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf01.png
// module id = 118
// module chunks = 0